import React from "react";

function WhyTokenize() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Tokenize Assets with Xeer Technology?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Tokenization has revolutionized ownership, providing
                  fractional ownership of tangible assets like real estate, art,
                  commodities, and even intellectual property. By leveraging
                  blockchain, we enable a cost-effective, secure, and accessible
                  way for individuals and institutions to invest in high-value
                  assets.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyTokenize;
